import { Dayjs } from "dayjs";
import { TimePeriod } from "../../../../shared/enums/timePeriods.enum";
import { DateModel } from "../../../../shared/models/date.model";
import { EfficiencySummary, UsageEfficiencySummary, EfficiencySummaryListRow, SortDirection, VisibleColumnsState, ColumnOrder, GroupByField, EfficiencyBasis } from "../models/efficiencySummary.model";

export interface EfficiencySummaryInitialState {
    selectedKey: TimePeriod;
    dailyEfficiencySummary: EfficiencySummary[];
    weeklyEfficiencySummary: EfficiencySummary[];
    yearlyEfficiencySummary: EfficiencySummary[];
    dailyUsageEfficiencySummary: UsageEfficiencySummary[];
    weeklyUsageEfficiencySummary: UsageEfficiencySummary[];
    yearlyUsageEfficiencySummary: UsageEfficiencySummary[];
    dailyEfficiencySummaryExport: EfficiencySummaryListRow[];
    weeklyEfficiencySummaryExport: EfficiencySummaryListRow[];
    yearlyEfficiencySummaryExport: EfficiencySummaryListRow[];
    dailyUsageEfficiencySummaryExport: UsageEfficiencySummary[];
    weeklyUsageEfficiencySummaryExport: UsageEfficiencySummary[];
    yearlyUsageEfficiencySummaryExport: UsageEfficiencySummary[];
    organizations: string[];
    companies: string[];
    departments: string[];
    tags: string[];
    models: string[];
    activities: string[];
    forklits: string[];
    dates: DateModel;
    showFilters: boolean;
    startDate: Dayjs | null;
    endDate: Dayjs | null;
    isAlternative: boolean;
    workingHours: number;
    weeklyWorkingHours: number;
    monthlyWorkingHours: number;
    remoteUpdate: any;
    listPage: number;
    listPageSize: number;
    listTotalCount: number;
    listSortBy: string;
    listSortDirection: SortDirection;
    listData: EfficiencySummaryListRow[];
    listLoading: boolean;
    visibleColumns: VisibleColumnsState;
    columnOrder: ColumnOrder;
    groupBy: GroupByField;
    efficiencyBasis: EfficiencyBasis;
}

const initialEfficiencySummaryState: EfficiencySummaryInitialState = {
    selectedKey: TimePeriod.Daily,
    dailyEfficiencySummary: [],
    weeklyEfficiencySummary: [],
    yearlyEfficiencySummary: [],
    dailyUsageEfficiencySummary: [],
    weeklyUsageEfficiencySummary: [],
    yearlyUsageEfficiencySummary: [],
    dailyEfficiencySummaryExport: [],
    weeklyEfficiencySummaryExport: [],
    yearlyEfficiencySummaryExport: [],
    dailyUsageEfficiencySummaryExport: [],
    weeklyUsageEfficiencySummaryExport: [],
    yearlyUsageEfficiencySummaryExport: [],
    organizations: [],
    companies: [],
    departments: [],
    forklits: [],
    tags: [],
    models: [],
    activities: [],
    dates: {
        startDate: null,
        endDate: null
    },
    showFilters: true,
    startDate: null,
    endDate: null,
    isAlternative: false,
    workingHours: 24,
    weeklyWorkingHours: 168,
    monthlyWorkingHours: 720,
    remoteUpdate: null,
    listPage: 1,
    listPageSize: 10,
    listTotalCount: 0,
    listSortBy: 'ForkliftName',
    listSortDirection: 'Ascending',
    listData: [],
    visibleColumns: {
        forkliftName: true,
        companyName: true,
        departmentName: true,
        activity: true,
        model: true,
        tags: true,
        summary: true
    },
    columnOrder: ['forkliftName', 'companyName', 'departmentName', 'activity', 'model', 'tags', 'summary'],
    listLoading: false,
    groupBy: 'none',
    efficiencyBasis: EfficiencyBasis.Ignition
}

export default initialEfficiencySummaryState